<script>
    import {
        dictionary,
        l1Description,
    } from "@app/services/currentDictionary.service";
    import {
        COMMON__more,
        COMMON__noSuchLanguage,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import ItemsList from "components/ItemsList/ItemsList.svelte";
    import { getItemsListManagerState } from "components/ItemsList/ItemsListManager";
    import { searchPhrase } from "../Search/Search.store";

    export let languageType = "source";
    const state = getItemsListManagerState();

    const dictionarySearchInput = document.getElementById("dictionary-search");

    const allLanguagesBrowserLinkParams = new Map([
        ["return", "change-language-redirect"],
        ["type", languageType],
        ["l1", $dictionary.l1.code],
        ["l2", $dictionary.l2.code],
        [
            "phrase",
            dictionarySearchInput != null ? dictionarySearchInput.value : "",
        ],
    ]);

    const allLanguagesBrowserLink =
        "/change-language?" +
        [...allLanguagesBrowserLinkParams.entries()]
            .map(
                (entry) =>
                    `${encodeURIComponent(entry[0])}=${encodeURIComponent(
                        entry[1]
                    )}`
            )
            .join("&");
</script>

{#if !$state.inProgress && $state.totalItems < 1}
    <p class="text-center mt-4">{getMessage(COMMON__noSuchLanguage)}</p>
{/if}
<ItemsList
    groups={$state.groups}
    activeIndex={$state.activeIndex}
    let:item={language}
    let:active
>
    <div class="w-full h-full">
        <button
            class="flex w-full items-center  bg-white rounded shadow py-1 border-2"
            class:border-tertiary-600={active}
            class:border-transparent={!active}
            data-languagecode={language.code}
        >
            <div
                class="flex-1 text-left items-center px-2 text-base w-full break-words	"
            >
                {language.name}
                <sup class="text-xs text-gray-600 ">
                    {language.code}
                </sup>
            </div>
        </button>
    </div>
</ItemsList>
<div class="text-center block border-t pt-4">
    <a href={allLanguagesBrowserLink}>{getMessage(COMMON__more)}...</a>
</div>

<style>
    .break-words {
        overflow-wrap: break-word;
        word-wrap: break-word;
    }
</style>
